// extracted by mini-css-extract-plugin
export default {"wrapper":"paradigm_wrapper__GAHJZ","bg":"paradigm_bg__sOpHM","title":"paradigm_title__VZMtL","pannel":"paradigm_pannel__TbuA2","content":"paradigm_content__gLtxp"};